export default "__VITE_ASSET__DSeNEq0H__"